import { useAuth0 } from "@auth0/auth0-react";
import Login from "./Login";
import Logout from "./Logout";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useTwitterContext } from "../TwitterContext";
import Search from "./Search";

function Header() {
    const { isAuthenticated, isLoading } = useAuth0();
    const navigate = useNavigate();
    const { updateTweetList } = useTwitterContext();

    async function JumpToHome() {
      navigate('/');
      updateTweetList();
    }
    // If the user is not authenticated, redirect to the home page
    if (!isLoading && !isAuthenticated) {
      return (
        <div className="top-bar">
          <div className="top-icon-div">
            <FontAwesomeIcon icon={faTwitter} className="top-icon" onClick={JumpToHome} alt="twitter"/>
          </div>
          <Search />
          <Login />
        </div>
      );
    }
  
    // Otherwise, display the children (the protected page)
    return (
      <div className="top-bar">
        <div className="top-icon-div">
          <FontAwesomeIcon icon={faTwitter} className="top-icon" onClick={JumpToHome} alt="twitter"/>
        </div>
        <Search />
        <Logout />
      </div>
  );
}

export default Header;